import React from "react";

function AquariumFishForm({ additionalAttributes, setAdditionalAttributes }) {
  
  // 🔹 Checkbox dəyişiklik funksiyası
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    let updatedList = checked
      ? [...(additionalAttributes.accessories || []), name] // Əgər seçilibsə, əlavə et
      : (additionalAttributes.accessories || []).filter(item => item !== name); // Seçim çıxarılsa, filter et

    setAdditionalAttributes({
      ...additionalAttributes,
      accessories: updatedList
    });
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    
    // 🔹 Number input-ları parse et
    const newValue = type === "number" ? parseInt(value) : value;
    
    // 🔹 Boolean input-ları düzəlt (true/false)
    const finalValue = name === "includesAquarium" ? (value === "Bəli") : newValue;

    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: finalValue,
    });
  };

  return (
    <div className="aquariumFishForm">
      {/* Balıq növü */}
      <div>
        <h3>Balıq növü <span>*</span></h3>
        <select name="fishType" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Qızıl balıq">Qızıl balıq</option>
          <option value="Betta">Betta</option>
          <option value="Koi">Koi</option>
          <option value="Neon Tetra">Neon Tetra</option>
          <option value="Guppy">Guppy</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş <span>*</span></h3>
        <input type="number" name="age" min="0" max="20" required placeholder="Yaşı daxil edin" onChange={handleChange} />
      </div>

      {/* Cins */}
      <div>
        <h3>Cins <span>*</span></h3>
        <select name="gender" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
          <option value="Naməlum">Naməlum</option>
        </select>
      </div>

      {/* Ölçü */}
      <div>
        <h3>Ölçü (sm) <span>*</span></h3>
        <input type="number" name="size" min="1" max="100" required placeholder="Ölçünü daxil edin" onChange={handleChange} />
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
        </select>
      </div>

      {/* Akvarium daxildirmi? */}
      <div>
        <h3>Akvarium daxildirmi? <span>*</span></h3>
        <select name="includesAquarium" required onChange={handleChange} defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

      {/* Akvarium həcmi */}
      <div>
        <h3>Akvarium həcmi (Litr) <span>*</span></h3>
        <input type="number" name="aquariumVolume" min="1" max="1000" required placeholder="Litr daxil edin" onChange={handleChange} />
      </div>

      {/* Aksesuarlar */}
      <div>
        <h3>Aksesuarlar daxildirmi? <span>*</span></h3>
        <div className="checkbox-group">
          <label>
            <input 
              type="checkbox" 
              name="Filtr və işıqlandırma" 
              onChange={handleCheckboxChange} 
              checked={additionalAttributes.accessories?.includes("Filtr və işıqlandırma")}
            /> Filtr və işıqlandırma
          </label>
          <label>
            <input 
              type="checkbox" 
              name="Dekorasiya" 
              onChange={handleCheckboxChange} 
              checked={additionalAttributes.accessories?.includes("Dekorasiya")}
            /> Dekorasiya
          </label>
          <label>
            <input 
              type="checkbox" 
              name="Qida və qidalandırıcı" 
              onChange={handleCheckboxChange} 
              checked={additionalAttributes.accessories?.includes("Qida və qidalandırıcı")}
            /> Qida və qidalandırıcı
          </label>
          <label>
            <input 
              type="checkbox" 
              name="Oksigen nasosu" 
              onChange={handleCheckboxChange} 
              checked={additionalAttributes.accessories?.includes("Oksigen nasosu")}
            /> Oksigen nasosu
          </label>
        </div>
      </div>
    </div>
  );
}

export default AquariumFishForm;
